import { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import styled from 'styled-components'

import { useGetBuyBarCopyQuery } from 'api/productVariantsApi'
import { useProductTemplateContext } from 'productTemplate/components/ProductTemplateContextProvider'
import { useShoppingRegionContext } from 'shared/contexts/ShoppingRegionContextProvider'
import { colors, fonts } from 'shared/lib'

const OrderBy = styled.span`
  ${fonts.SUBTITLE_3}
  color: ${colors.FC2_GREY};
`

interface IInstantShipCallOut {
  qaAttr?: string
}

export const InstantShipCallOut: FC<IInstantShipCallOut> = ({ qaAttr }) => {
  const { country } = useShoppingRegionContext()
  const { productTemplate } = useProductTemplateContext()
  const { slug } = productTemplate
  const { data } = useGetBuyBarCopyQuery({ slug, country })

  return (
    <div data-qa={qaAttr}>
      <OrderBy>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {data?.buyBarFastestToYouCopy ||
            'Pre-verified and ready to ship from a Flight Club facility'}
        </ReactMarkdown>
      </OrderBy>
    </div>
  )
}
